import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import {
  withMobileDialog,
  Dialog,
  withStyles,
  IconButton,
} from '@material-ui/core'
import { Close, Edit, Done, ArrowBack } from '@material-ui/icons'
import { toggleDialog } from 'actions/view'
import Field from 'components/theme/Field'
import { read, create } from 'actions/data'
import { DATA_API_URL } from 'utils/AllURLs'
import MarkdownWithEllipsis from 'components/VastGPT/MarkdownWithEllipsis'
import Editor from './Editor'

const initialState = () => ({
  content: '',
  title: '',
  editing: false,
  savedOrCancelled: null,
  cancelAttempt: false,
  // cancelConfirmed: false,
})

class AddOrEditKnowledgeDialog extends Component {
  constructor(props) {
    super(props)

    this.state = initialState()
  }

  // componentDidMount() {
  //   console.log('AddOrEditKnowledgeDialog componentDidMount')
  // }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.dialogOpen !== prevProps.dialogOpen ||
      this.props.id !== prevProps.id
    ) {
      if (this.props.id && this.props.id !== 'new') {
        this.props
          .read(
            this.props.id,
            'knowledge',
            null,
            null,
            'object',
            null,
            null,
            `${DATA_API_URL}/knowledge/${this.props.id}`,
          )
          .then(payload => {
            this.setState({
              content: payload?.content,
              title: payload?.title,
            })
          })
      } else {
        if (this.props.id === 'new') {
          this.setState({ editing: true })

          if (this.props.title) {
            this.setState({
              title: this.props.title,
            })
          }

          if (this.props.content) {
            this.setState({
              content: this.props.content,
            })
          }
        }
      }
    }
  }

  render() {
    return (
      <Dialog
        fullWidth
        fullScreen
        open={Boolean(this.props.dialogOpen)}
        onClose={() => {
          this.setState(initialState())
          this.props.toggleDialog({
            open: false,
            dialog: 'AddOrEditKnowledge',
          })
        }}
        aria-labelledby="responsive-dialog-title"
        PaperProps={{
          classes: {
            rounded: this.props.classes.rounded,
          },
        }}
      >
        <div
          style={{
            position: 'fixed',
            top: 0,
            width: '100%',
            backgroundColor: '#fff',
            zIndex: 1,
            height: 58,
            borderBottom: '1px solid gray',
          }}
        >
          <div style={{ position: 'relative', width: '100%', height: '100%' }}>
            <div
              style={{
                position: 'absolute',
                top: 2,
                left: 5,
                zIndex: 2,
              }}
            >
              {this.state.editing ? (
                <IconButton
                  onClick={() => {
                    // this.setState({ savedOrCancelled: 'cancelled' }, () => {
                    //   this.setState({ editing: false }, () => {
                    //     this.setState({ savedOrCancelled: null })
                    //   })
                    // })

                    this.setState({ cancelAttempt: true }, () => {
                      console.log('post setState')
                    })
                  }}
                >
                  <Close />
                </IconButton>
              ) : (
                <IconButton
                  onClick={() => {
                    this.setState(initialState())
                    this.props.toggleDialog({
                      open: false,
                      dialog: 'AddOrEditKnowledge',
                    })
                  }}
                >
                  <ArrowBack />
                </IconButton>
              )}
            </div>
            {this.state.editing ? (
              <div
                style={{
                  marginLeft: 62,
                  width: 'calc(100% - 124px)',
                  marginTop: 3,
                  zIndex: 2,
                }}
              >
                <Field
                  label="Title/Question"
                  placeholder="Give a clear title or question for this knowledge item"
                  variant="standard"
                  value={this.state.title}
                  handleChange={(name, value) =>
                    this.setState({ title: value })
                  }
                />
              </div>
            ) : (
              <div
                style={{
                  marginLeft: 62,
                  width: 'calc(100% - 124px)',
                  zIndex: 2,
                  fontSize: 20,
                  fontWeight: 500,
                  paddingTop: 16,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {this.state.title}
              </div>
            )}
            <div
              style={{
                position: 'absolute',
                top: 2,
                right: 5,
                zIndex: 2,
              }}
            >
              {this.state.editing ? (
                <IconButton
                  disabled={!this.state.title}
                  onClick={() => {
                    this.setState({ savedOrCancelled: 'saved' }, () => {
                      this.setState({ editing: false }, () => {
                        this.setState({ savedOrCancelled: null })
                      })
                    })
                  }}
                >
                  <Done />
                </IconButton>
              ) : (
                <IconButton
                  onClick={() => {
                    this.setState({ editing: true })
                  }}
                >
                  <Edit />
                </IconButton>
              )}
            </div>
          </div>
        </div>
        <div
          style={{
            marginTop: 58,
            maxHeight: 'calc(100vh - 58px)',
            overflowY: 'auto',
          }}
        >
          {this.state.editing ? (
            <Editor
              knowledgeId={this.props.id}
              setSavedOrCancelled={savedOrCancelled => {
                if (savedOrCancelled === 'cancelled') {
                  this.setState({ savedOrCancelled }, () => {
                    this.setState({ editing: false }, () => {
                      if (this.props.id === 'new') {
                        this.setState(initialState())

                        this.props.toggleDialog({
                          open: false,
                          dialog: 'AddOrEditKnowledge',
                        })
                      }
                    })
                  })
                }
              }}
              handleChange={content => {
                console.log(content)

                if (this.state.savedOrCancelled === 'saved') {
                  this.setState({ content })

                  this.props
                    .create({
                      entity: {
                        id: this.props.id === 'new' ? undefined : this.props.id,
                        title: this.state.title || undefined,
                        content,
                        internal: true,
                        external: false,
                      },
                      entityType: 'knowledge',
                      url: `${DATA_API_URL}/knowledge`,
                      hasSchema: false,
                      snackbarMessage:
                        this.props.id === 'new'
                          ? 'Knowledge created!'
                          : 'Knowledge updated!',
                    })
                    .then(payload => {
                      this.props.toggleDialog({
                        open: true,
                        dialog: 'AddOrEditKnowledge',
                        options: {
                          id: payload.id,
                        },
                      })
                    })
                }

                // if (this.state.savedOrCancelled === 'cancelled') {
                //   this.setState(initialState())
                // }
              }}
              editing={this.state.editing /* LEAVE THIS, IT'S NECESSARY */}
              content={this.state.content}
              cancelAttempt={this.state.cancelAttempt}
            />
          ) : (
            <div
              style={{
                padding: '0 20px 20px',
              }}
            >
              <MarkdownWithEllipsis markdown={this.state.content} />
            </div>
          )}
        </div>
      </Dialog>
    )
  }
}

export default withRouter(
  connect(
    state => ({
      dialogOpen: state.view.dialogs?.AddOrEditKnowledge?.open,
      editing: state.view.dialogs?.AddOrEditKnowledge?.editing,
      id: state.view.dialogs?.AddOrEditKnowledge?.id,
      content: state.view.dialogs?.AddOrEditKnowledge?.content,
      title: state.view.dialogs?.AddOrEditKnowledge?.title,
    }),
    dispatch =>
      bindActionCreators(
        {
          toggleDialog,
          read,
          create,
        },
        dispatch,
      ),
  )(
    withMobileDialog()(
      withStyles(theme => ({
        rounded: {},
        dialogContentRoot: {
          position: 'relative',
          padding: 0,
          '&:first-child': {
            paddingTop: 0,
          },
        },
        dialogActionsRoot: {
          display: 'block',
          margin: 0,
        },
      }))(AddOrEditKnowledgeDialog),
    ),
  ),
)
